module.exports = __webpack_public_path__ + "img/b90916327ca31d44a9caad7cb1a1e7ff.svg";